/* PurePetZone — i pulsanti degli argomenti nelle domande frequenti.

   NON sono scritti da nessuna parte: si costruiscono leggendo i gruppi di
   domande che stanno in pagina. Scritti a mano si sarebbero scollegati alla
   prima domanda spostata o rinominata, e che un pulsante punta nel vuoto lo si
   scopre solo cliccandolo.

   Le file sono due, sopra e in fondo alla pagina, e questo file le tratta tutte
   allo stesso modo: se un domani se ne aggiunge una terza funziona da sola.

   Nessun pulsante resta acceso mentre si scorre: si e' scelto di tenerli tutti
   uguali. Per questo qui non c'e' niente in ascolto sullo scorrimento della
   pagina: il lavoro finisce appena i pulsanti sono disegnati.

   Senza JavaScript le file restano vuote e spariscono: sono scorciatoie, le
   domande restano tutte leggibili scorrendo la pagina. */

(function () {
  'use strict';

  /* UNA VOLTA SOLA. La sezione dei pulsanti sta in pagina due volte, sopra e in
     fondo, e ognuna si porta dietro il proprio richiamo a questo file: il
     browser non li unisce, li esegue tutti e due. Senza questo blocco i
     pulsanti venivano disegnati in doppio. */
  if (window.ppzFaqNavFatto) return;
  window.ppzFaqNavFatto = true;

  var file = document.querySelectorAll('[data-ppz-faq-chips]');
  if (!file.length) return;

  var gruppi = document.querySelectorAll('[data-ppz-faq-group]');
  if (gruppi.length < 2) return; /* con un argomento solo non c'e' niente da scegliere */

  Array.prototype.forEach.call(file, function (fila) {
    Array.prototype.forEach.call(gruppi, function (g) {
      var a = document.createElement('a');
      a.className = 'ppz-faqchips__chip';
      a.href = '#' + g.id;
      /* Nel pulsante va il nome corto; il titolo per esteso resta sulla
         pillola dell'argomento, dove c'e' spazio. */
      a.textContent = g.getAttribute('data-chip') || g.getAttribute('data-titolo') || '';
      fila.appendChild(a);
    });
  });
})();
